export default __webpack_public_path__ + "static/media/f_logo.a13123be.webp";